import app from "@@assets/scripts/app";

function importSlick() {
	const slickCDN = "//cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick";
	
	return Promise.all([
		new Promise( (resolve, reject) => app.require(
			`${slickCDN}/slick.min.js`,
			{
				success: resolve,
				error: reject
			})
		),
		new Promise( (resolve, reject) => app.require(
			`${slickCDN}/slick.css`,
			{
				type: "stylesheet",
				success: resolve,
				error: reject
			})
		),
		new Promise( (resolve, reject) => app.require(
			`${slickCDN}/slick-theme.css`,
			{
				type: "stylesheet",
				success: resolve,
				error: reject
			})
		)
	]);
}

const defaultSlickOptions = {
	fade: true,
	autoplay: true,
	dots: true,
	arrows: false,
	speed: 600,
	adaptiveHeight: false,
	pauseOnFocus: false,
	cssEase: "linear"
};

export default importSlick;
export { defaultSlickOptions };
